<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import AuCallout from '~/components/ui/AuCallout.vue'

const { t } = useI18n()
</script>

<template>
  <AuCallout
    variant="warning"
    class="mb-4"
    :title="t('register.error.loggedIn')"
  />
</template>
